// extracted by mini-css-extract-plugin
module.exports = {"input":"TreeInput_input__2pgOp","addButton":"TreeInput_addButton__W9RCd"};